/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KpiResponse
 */
export interface KpiResponse {
    /**
     * 
     * @type {number}
     * @memberof KpiResponse
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof KpiResponse
     */
    userName: string;
    /**
     * 
     * @type {object}
     * @memberof KpiResponse
     */
    data: object;
}

/**
 * Check if a given object implements the KpiResponse interface.
 */
export function instanceOfKpiResponse(value: object): value is KpiResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function KpiResponseFromJSON(json: any): KpiResponse {
    return KpiResponseFromJSONTyped(json, false);
}

export function KpiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): KpiResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'userName': json['userName'],
        'data': json['data'],
    };
}

export function KpiResponseToJSON(json: any): KpiResponse {
    return KpiResponseToJSONTyped(json, false);
}

export function KpiResponseToJSONTyped(value?: KpiResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userName': value['userName'],
        'data': value['data'],
    };
}

